import './cta.css'

const CTA = () => {
  return (
    <div className='max-width'>
      <div className='gpt3__cta'>
        <div className='gpt3__cta-content'>
          <p>Request Early Access to Get Started</p>
          <h3>Request Early Access to Get Started</h3>
        </div>
        <div className='gpt3__cta-btn'>
          <button type='button'>Get Started</button>
        </div>
      </div>
    </div>
  )
}

export default CTA
